export const DYNAMIC_SPEC_SHEET = "dynamic_spec_sheet";
